(function ($, Cobalt, undefined) {
    Cobalt.BunnyEars = {
        configOptions: {},
        contentWrapper: null,
        liveOnTwitchCon: null,
        liveOnTwitchBtn: null,
        api: null,
        loading: false,
        contentLoaded: false,
        sendHoverEventToGA: false,
        initialize: function () {
            $(function () {
                // first make sure Google Analytics is initialized
                Cobalt.Analytics.initialize();

                var configEl = $('.cobalt-bunny-ears-config');
                if (configEl.data('track-hover')) {
                    Cobalt.BunnyEars.sendHoverEventToGA = true;
                }

                if (configEl.length) {
                    // Add BunnyEars initialization to GA's command queue, ensuring GA is initialized before loading BunnyEars
                    ga(function() {
                        Cobalt.BunnyEars.configOptions = configEl.data();
                        // doing $.ajax with async: false to prevent it from calling success before executing 
                        $.ajax({
                            url: 'https://stations.cursetech.com/be/bunnyears-1.1.min.js',
                            dataType: 'script',
                            success: Cobalt.BunnyEars.onBunnyEarsScriptLoad,
                            async: false
                        });
                    });
                }
            });
        },
        showContent: function () {
            if (!Cobalt.BunnyEars.loading && !Cobalt.BunnyEars.loaded) {
                Cobalt.BunnyEars.tuneBunnyEars();
            }

            // handle hiding and showing elements so we keep the show more view.
            var firstOffset = null;
            var hidden = 0;

            Cobalt.BunnyEars.contentWrapper.show();

            // Drop the class for all as too not break logic.
            Cobalt.BunnyEars.contentWrapper
                .find('.beFlexItem')
                .show()
                .removeClass('beFlexHidden beFlexShowing')
                .each(function () {
                    var $this = $(this);
                    var offsetTop = $this.offset().top;

                    if (!firstOffset) {
                        firstOffset = offsetTop;
                    }

                    if (!$this.hasClass('beFlexItemMore')) { // leave the last one alone.
                        if (offsetTop == firstOffset) {
                            $this.addClass('beFlexShowing').removeClass('beFlexHidden');
                        } else {
                            $this.removeClass('beFlexShowing').addClass('beFlexHidden');
                            hidden++;
                        }
                    }
                });

            // hide last showing so we can load up get more
            if (hidden) {
                Cobalt.BunnyEars.contentWrapper
                    .find('.beFlexShowing')
                    .last()
                    .removeClass('beFlexShowing')
                    .addClass('beFlexHidden');
            } else {
                var flexItemMore = Cobalt.BunnyEars.contentWrapper.find('.beFlexItemMore');
                if (flexItemMore.length && flexItemMore.offset().top !== firstOffset) {
                    // not hidden, so lets see if the beFlexItemMore is hidden
                    // we have hit the "all the streams are showing but no show more edge case"
                    Cobalt.BunnyEars.contentWrapper
                        .find('.beFlexShowing')
                        .last()
                        .removeClass('beFlexShowing')
                        .addClass('beFlexHidden');
                }
            }

            Cobalt.BunnyEars.contentWrapper.find('.beFlexShowing').show();
            Cobalt.BunnyEars.contentWrapper.find('.beFlexHidden').hide();
        },
        hideContent: function () {
            Cobalt.BunnyEars.contentWrapper.hide();
            Cobalt.BunnyEars.contentWrapper
                .find('.beFlexItem')
                .show()
                .removeClass('beFlexShowing beFlexHidden');
        },
        onBunnyEarsScriptLoad: function () {
            // append needed HTML elements to the page
            var insertionEl = $('.netbar .netbar-help');
            if (!insertionEl.length) {
                insertionEl = $('.netbar .netbar-support');
            }
            if (!insertionEl.length) {
                // We have no expected elements to anchor to so just don't do anything
                return;
            }
            Cobalt.BunnyEars.contentWrapper = $('<div id="lotBeWrapper" />').appendTo('body');
            Cobalt.BunnyEars.liveOnTwitchCon = $('<div class="live-on-twitch netbar-left"><span class="live-on-twitch-btn" /></div>').insertAfter(insertionEl);
            Cobalt.BunnyEars.liveOnTwitchBtn = Cobalt.BunnyEars.liveOnTwitchCon.find('.live-on-twitch-btn');

            Cobalt.BunnyEars.liveOnTwitchBtn
                .add(Cobalt.BunnyEars.contentWrapper)
                .on('mouseenter', function () {
                    Cobalt.BunnyEars.liveOnTwitchBtn.addClass('live-on-twitch-btn-hover');
                    Cobalt.BunnyEars.showContent();
                    if (Cobalt.BunnyEars.sendHoverEventToGA) {
                        Cobalt.Analytics.sendEvent('BunnyEars', 'HoverMenu');
                        Cobalt.BunnyEars.sendHoverEventToGA = false;
                    }
                })
                .on('mouseleave', function () {
                    Cobalt.BunnyEars.liveOnTwitchBtn.removeClass('live-on-twitch-btn-hover');
                    Cobalt.BunnyEars.hideContent();
                });
        },
        tuneBunnyEars: function () {
            if (Cobalt.BunnyEars.loading) {
                return;
            }
            Cobalt.BunnyEars.contentWrapper.mask();
            //Cobalt.BunnyEars.contentWrapper.addClass('bunnyEarsTuning');
            Cobalt.BunnyEars.api = new BunnyEars().tuneIn("#lotBeWrapper", Cobalt.BunnyEars.configOptions, Cobalt.BunnyEars.onBunnyEarsTuned);
            Cobalt.BunnyEars.loading = true;
        },
        onBunnyEarsTuned: function () {
            //Cobalt.BunnyEars.contentWrapper.removeClass('bunnyEarsTuning');
            Cobalt.BunnyEars.contentWrapper.unmask();
            Cobalt.BunnyEars.loading = false;
            Cobalt.BunnyEars.loaded = true;
        },
    };

})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.BunnyEars.js